import { render, staticRenderFns } from "./VendorNew.vue?vue&type=template&id=042b3aaa"
import script from "./VendorNew.vue?vue&type=script&lang=js"
export * from "./VendorNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042b3aaa')) {
      api.createRecord('042b3aaa', component.options)
    } else {
      api.reload('042b3aaa', component.options)
    }
    module.hot.accept("./VendorNew.vue?vue&type=template&id=042b3aaa", function () {
      api.rerender('042b3aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vendor/VendorNew.vue"
export default component.exports